import { ItemModalVencedorLicitacao } from "@/types/licitacoes/ldi/item-modal-vencedor-licitacao";
import { Paginacao } from "@/types/paginacao";

export class RetornoModalVencedorLicitacao extends Paginacao {
  itens: ItemModalVencedorLicitacao[] = [];
  licitacaoVlTotalEstimado = 0;
  licitacaoVlTotalLicitado = 0;

  constructor(obj: any, idParticipante: number, page = 1, pageSize = 50) {
    super();
    if (!obj) return;

    this.itens = (obj.itens ?? [])
      .map((i: any) => new ItemModalVencedorLicitacao(i, idParticipante))
      .filter((i) => i.IdItemLicitacao != null);
    this.licitacaoVlTotalEstimado = obj.licitacaoVlTotalEstimado ?? 0;
    this.licitacaoVlTotalLicitado = obj.licitacaoVlTotalLicitado ?? 0;
    this.totalRows = obj.totalRows ?? this.itens.length;
    this.page = obj.page ?? page;
    this.pageSize = obj.pageSize ?? pageSize;
  }
}
